import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { useReturnExchangeArchivesValueContextHook } from "../../../../contexts/ReturnExchangeArchivesContext";
import { useSelectedReturnExchangesActionsContextHook, useSelectedReturnExchangesValueContextHook } from "../../../../contexts/SelectedReturnExchangesContext";
import _ from "lodash";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import { ReturnExchangesApi } from "../../../../../../../apis/ReturnExchangesApi";
import { useFetcher } from "../../../../fetcher/useFetcher";

const StyledArchiveSelectorModalHeader = styled.div`
    padding: 10px;
`;

const StyledArchiveSelectorModalBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    button{
        border-radius: 3px;
        font-weight: 600;
        transition: border-color 0.3s;
        border:none;

        &:hover{
            border-color: #333;
        }
    }
`;
export function ModalSelectArchive({
    open,
    onClose,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const selectedReturnExchangesValueContextHook = useSelectedReturnExchangesValueContextHook();
    const selectedReturnExchangesActionsContextHook = useSelectedReturnExchangesActionsContextHook();
    const returnExchangeArchivesValueContextHook = useReturnExchangeArchivesValueContextHook();
    const fetcher = useFetcher();

    const archives = returnExchangeArchivesValueContextHook?.returnExchangeArchives;

    const handleSelect = async (archive) => {
        let newReturnExchanges = _.cloneDeep(selectedReturnExchangesValueContextHook?.selectedReturnExchanges);
        if (!archive) {
            newReturnExchanges.forEach(item => {
                item.returnExchangeArchiveId = null;
            });
        } else {
            newReturnExchanges.forEach(item => {
                item.returnExchangeArchiveId = archive?._id;
            });
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: newReturnExchanges
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
            selectedReturnExchangesActionsContextHook.selectedReturnExchanges.onSet([]);
            onClose();
        }
        CustomBackdropController().hideBackdrop();

    }

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
        >
            <StyledArchiveSelectorModalHeader>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        보관함 이동
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={onClose} />
                </CustomDialog.Header>
            </StyledArchiveSelectorModalHeader>
            <StyledArchiveSelectorModalBody>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSelect(null)}
                    style={{backgroundColor:'#efefef', color: '#333'}}
                >
                    전체
                </CustomBlockButton>
                {archives?.map((item, index) => {
                    return (
                        <CustomBlockButton
                            key={item?._id}
                            type='button'
                            onClick={() => handleSelect(item)}
                            style={{backgroundColor: item?.backgroundColor || '#efefef', color: item?.fontColor || '#333'}}
                        >
                            {item?.name}
                        </CustomBlockButton>
                    );
                })}
            </StyledArchiveSelectorModalBody>
        </CustomDialog>
    )
}